import { useMediaQuery, Box, useTheme, Card, SxProps, Theme, styled } from '@mui/material';
import { ReactElement, ReactNode } from 'react';

const outerPadding = 10;

export interface SelfServicePageLayoutProps {
  children: ReactNode;
  slotProps?: { boxProps?: { sx: SxProps<Theme> }; cardProps?: { sx: SxProps<Theme> } };
}

export function MobileFirstContainer({ children, slotProps }: SelfServicePageLayoutProps): ReactElement {
  const { boxProps, cardProps } = slotProps || {};
  const theme = useTheme();

  return (
    <OuterContainer {...boxProps}>
      <InnerCard {...cardProps} elevation={useMediaQuery(theme.breakpoints.down('md')) ? 0 : 10}>
        {children}
      </InnerCard>
    </OuterContainer>
  );
}

const OuterContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  [theme.breakpoints.up('md')]: {
    height: `calc(100% - ${theme.spacing(outerPadding)})`,
    width: `calc(100% - ${theme.spacing(2 * outerPadding)})`,
    padding: theme.spacing(outerPadding),
  },
  [theme.breakpoints.down('md')]: {
    height: '100%',
    width: '100%',
    padding: 0,
  },
}));

const InnerCard = styled(Card)<{ theme?: Theme }>(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  [theme!.breakpoints.up('md')]: {
    maxWidth: '35em',
    height: `calc(100vh - ${theme!.spacing(2 * outerPadding)})`,
    borderRadius: '15px',
  },
  [theme!.breakpoints.down('md')]: {
    maxWidth: '100vw',
    height: '100dvh', // Use dynamic viewport height to account for mobile browser UI
    borderRadius: 0,
  },
}));
